import { FunctionComponent, useEffect } from "react";
import { CheckIcon, CloseIcon } from "@form/components/common/icons";
import useAccount from "@/hooks/useAccount";
import { trimAddr1 } from "@/utils/format";
import useVerifyClaim from "@/hooks/useVerifyClaim";
import useToggleStatus from "@/hooks/useToggleStatus";
import { useBalance } from "wagmi";
import { KARATDAO_DEFAULT_SUPPORTED_CHAINS } from "@/chain-info/KaratDaoSupportedChain";

const ConnectWalletStep: FunctionComponent<{ chainId: number }> = ({
  chainId,
}) => {
  const { login, isLogin, address, logout } = useAccount();
  const { changeVerifyState } = useVerifyClaim("account");
  const { open } = useToggleStatus("claimerMintToggleStatus");
  const mintChain = KARATDAO_DEFAULT_SUPPORTED_CHAINS.find((item) => {
    return item.chainId === chainId;
  })!;

  const { data: balance, refetch } = useBalance({
    address,
    chainId,
    watch: false,
  });

  const { data: ethBalance } = useBalance({
    address,
    chainId: 1,
    watch: false,
  });

  useEffect(() => {
    changeVerifyState(isLogin);
    isLogin && open("accounts");
  }, [isLogin]);

  return (
    <div className="claim-step-card">
      <div className="flex items-center">
        <CheckIcon
          className={`w-5 h-5 ${isLogin ? "fill-green" : ""}`}
        ></CheckIcon>
        <div className="font-semibold text-dark1 ml-2">Connect wallet</div>
        <div className="flex-1"></div>
        {isLogin ? (
          <div className="flex items-center">
            <span className="text-sm text-gray1 mr-1">
              {trimAddr1(address || "", 5)}
            </span>
            <div
              className="action ml-1 w-[14px] h-[14px] rounded-full bg-primary flex items-center justify-center"
              onClick={logout}
            >
              <CloseIcon className="w-[6px]"></CloseIcon>
            </div>
          </div>
        ) : (
          <div className="action text-primary font-semibold" onClick={login}>
            {address ? "Sign Message" : "Connect"}
          </div>
        )}
      </div>
      {address && (
        <div className="border-t border-t-[#E0E1E1] mt-4 pt-4 flex flex-wrap gap-5 sm:gap-10">
          <div className="text-sm">
            <div className="text-gary2 font-semibold">Wallet address</div>
            <div className="text-gray1 mt-1">{trimAddr1(address, 8)}</div>
          </div>
          <div className="text-sm">
            <div className="text-gary2 font-semibold">
              {mintChain.chainName} balance
            </div>
            <div className="text-gray1 mt-1">
              {parseFloat(balance?.formatted || "0").toFixed(3)}
              {mintChain.nativeCurrency?.symbol}
            </div>
          </div>
          <div className="text-sm">
            <div className="text-gary2 font-semibold">Ethereum balance</div>
            <div className="text-gray1 mt-1">
              {parseFloat(ethBalance?.formatted || "0").toFixed(3)}ETH
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConnectWalletStep;
